export const metaTitle = 'Hevy Coach';
export const metaDescription =
  'Hevy Coach is the best personal training software for coaches, personal trainers, strength coaches and other fitness professionals.';
export const metaImage =
  'https://hevycoach.com/wp-content/uploads/2023/11/hevy-coach-feature-image.png';
